<app-main-nav-bar></app-main-nav-bar>
<div class="main" data-request="1995">
  <div class="wrap">
    <div class="sub-request elem" style="display: block;">
      <div class="row">
        <div class="col col-12">
          <div class="head">
            <h2 style="text-align: center">اطلاعات دستگاه</h2>
            <p>در صورتی که اطلاعات مورد قبول می باشد تایید و در غیر این صورت بازگشت را فشار دهید</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-12">
          <app-details-div
            [rawCount]="3"
            [array]="viewInformation"
            [header]="'درخواست بیمه '"
            [id]="1"
            (takeAction)="submit()"
            [backUrl]="'/'+ productName + '/offers'"
            [mainLabel]="'تایید'"
            [backLabel]="'بازگشت'"
            [translation]="translation"
          ></app-details-div>
        </div>
      </div>
    </div>
  </div>
</div>
